module.exports = __webpack_public_path__ + "img/sign-53.45072d88.jpg";